<div class="total-padding" #shim></div>
<div class="scrollable-content" #content>
  <ng-content></ng-content>
</div>
